import React, {
    Fragment,
} from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaChevronRight from 'react-icons/lib/fa/chevron-right';
import LazyLoad from 'react-lazyload';

import A from 'wanderu-component-react-router-link';
import {
    Typography,
    BranchLink,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import phoneImage2x from 'wanderu-assets/images/homepage/flat-iphone-2x.png';
import phoneImage from 'wanderu-assets/images/homepage/flat-iphone.png';
import homescreenPhoneImage from 'wanderu-assets/images/homepage/homescreen-iphone.png';
import homescreenPhoneImage2x from 'wanderu-assets/images/homepage/homescreen-iphone2x.png';

import {
    APP_LINK,
} from '../../urls';
import TwoColumnLayout, {
    LeftColumn,
    RightColumn,
} from '../TwoColumnLayout/TwoColumnLayout';
import IconBar from './IconBar/IconBar';

import styles from './IntroMobileSection.scss';

const propTypes = {
    appPage: PropTypes.bool,
    campaign: PropTypes.string,
    className: PropTypes.string,
    t: PropTypes.func.isRequired,
};

function PhoneImage(props) {
    const {
        appPage,
    } = props;

    return (
        <img
            alt=""
            className={classNames(
                styles.phoneImage,
                {
                    [styles.tiny]: appPage,
                    [styles.semiHidden]: !appPage,
                },
            )}
            height="425"
            src={appPage
                ? phoneImage
                : homescreenPhoneImage}
            srcSet={`${appPage
                ? phoneImage2x
                : homescreenPhoneImage2x} 2x`}
            width="210"
        />
    );
}

PhoneImage.propTypes = {
    appPage: PropTypes.bool,
};

function IntroMobileSection(props) {
    const {
        t,
        appPage = false,
        className = '',
        campaign,
    } = props;

    return (
        <>
            <div id="gta-intro-section" />
            <section
                aria-labelledby="gta-intro"
                className={classNames(
                    styles.introMobileSection,
                    className,
                )}
            >

                <TwoColumnLayout
                    layoutClassName={styles.layout}
                >
                    <LeftColumn
                        className={classNames(
                            styles.leftColumn,
                            { [styles.largeGutter]: appPage },
                        )}
                    >
                        <Typography
                            className={classNames(
                                styles.title,
                                { [styles.smallerTitle]: appPage },
                            )}
                            id="gta-intro"
                            variant="h1"
                        >
                            {t('book-bus-and-train-travel')}
                        </Typography>

                        <p
                            className={classNames(
                                styles.subtitle,
                                { [styles.hiddenOnMobile]: appPage },
                            )}
                        >
                            {t('snag-the-best-deals')}
                            <BranchLink
                                className={classNames(
                                    styles.learnMore,
                                    { [styles.hidden]: appPage },
                                )}
                            >
                                {t('learn-more')}
                                <FaChevronRight className={styles.chevron} />
                            </BranchLink>
                        </p>

                        <div
                            className={classNames(
                                styles.availability,
                                {
                                    [styles.hiddenOnMobile]: appPage,
                                    [styles.withoutText]: !appPage,
                                },
                            )}
                        >
                            <IconBar
                                appPage={appPage}
                                campaign={campaign}
                                t={t}
                            />

                            <span
                                className={classNames(
                                    styles.availabilityText,
                                    { [styles.visible]: appPage },
                                )}
                            >
                                {t('available-on')}
                            </span>
                        </div>
                    </LeftColumn>

                    <RightColumn
                        className={classNames(
                            styles.rightColumn,
                            { [styles.semiHidden]: !appPage },
                        )}
                    >
                        {appPage
                            ? (
                                <Fragment>
                                    <PhoneImage appPage />
                                    <A
                                        className={styles.getTheAppButton}
                                        href={APP_LINK}
                                        native
                                    >
                                        {t('get-the-app')}
                                    </A>

                                    <span className={styles.bestNewApp}>
                                        <span className={styles.bestNewAppText}>
                                            {t('named-best-new-app')}
                                        </span>

                                        <IconBar
                                            appPage={appPage}
                                            campaign={campaign}
                                            t={t}
                                        />
                                    </span>
                                </Fragment>
                            )
                            : (
                                <BranchLink className={styles.phoneContainer}>
                                    <LazyLoad height={709}>
                                        <PhoneImage />
                                    </LazyLoad>
                                </BranchLink>
                            )}
                    </RightColumn>
                </TwoColumnLayout>
            </section>
        </>
    );
}

IntroMobileSection.propTypes = propTypes;

export {
    IntroMobileSection,
    PhoneImage,
};

export default localize(IntroMobileSection, ['t'], 'baseApp');
